import React from 'react';
import PropTypes from 'prop-types';
import { CommonIcons } from 'components/Icons';
import { SIZE_ICON } from 'consts/data';
import classNames from 'classnames';
import { copyToClipboard } from 'helpers';
import { notifySuccess } from 'helpers/handleNotification';
import { useTranslation } from 'react-i18next';
import { TooltipReactTooltip } from 'components/Tooltip';
import { uniqueId } from 'lodash';

const propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
};

const Copy = ({
  id = uniqueId('copy'),
  onClick,
  className,
  text = '',
  tooltip,
  portal,
  size = SIZE_ICON,
}) => {
  //! State
  const { t } = useTranslation();

  //! Function
  const onClickCopy = () => {
    copyToClipboard(text);
    notifySuccess(`${t('shared:copied')}!`);
  };

  //! Render
  return (
    <TooltipReactTooltip
      idTarget={`copy-${id}`}
      messageToolTip={tooltip || 'Copy' || t('shared:copy')}
      portal={portal || document.body}
      effect='solid'
    >
      <CommonIcons.Copy
        onClick={onClick || onClickCopy}
        size={size}
        className={classNames('is-hover icon-dzb', className)}
      />
    </TooltipReactTooltip>
  );
};

Copy.propTypes = propTypes;
export default React.memo(Copy);
